import script from "./TransitionExpand.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransitionExpand.vue?vue&type=script&setup=true&lang=ts"

import "./TransitionExpand.vue?vue&type=style&index=0&id=7ff53f1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff53f1d"]])

export default __exports__